import request from './request'
import {URL, DEFAULT_OPTION, IFRAME_URL} from './config'
import {noop, getCookie, getOrCreateLocalId} from './util'

class Report {
  constructor (data, options, uidFunc) {
    this.data = Object.assign({}, data);
    this.opts = Object.assign({}, DEFAULT_OPTION, options)
    this.uidFunc = uidFunc || noop
  }

  sendData (data, options, uidFunc) {
    const opts = Object.assign({}, this.opts, options)

    // 这里才调用window的相关api，适配ssr
    const reportData = Object.assign({
      appid: '', // 业务id，必填
      so: '', // 打点业务方，必填
      uid: getCookie('wasxuid_r'), // 小鹏用户id，必填
      ls: getOrCreateLocalId(), // 用户主键标识-前端，必填
      re: window.document.referrer, // 当前访问页面的url的referer，必填
      url: window.location.href, // 当前访问页面的url，必填
      type: 'page', // 类型，暴光（page）还是事件(event),留资（reserve），必填
      mcode: '', // 日志类型代码，事件日志是事件的具体代码，爆光日志可以为空，非必填
      ch: '', // 渠道来源，非必填
    }, this.data, data)

    // 默认uid获取function
    uidFunc = uidFunc || this.uidFunc

    if (uidFunc && typeof uidFunc === 'function') {
      let uidFuncResult = uidFunc()

      // 支持promise函数
      if (uidFuncResult && uidFuncResult.then) {
        uidFuncResult.then(uid => {
          reportData.uid = uid
          // 发请求，上报数据
          request(URL[opts.env], reportData);
        }, () => {
          console && console.warn && console.warn('提供的uid获取函数，获取uid错误！')
        });
      } else {
        if (uidFuncResult !== undefined) {
          reportData.uid = uidFuncResult
        }
        // 发请求，上报数据
        request(URL[opts.env], reportData);
      }
    } else {
      // 发请求，上报数据
      request(URL[opts.env], reportData);
    }
  }

  /**
   * 从统一的域名获取前端虚拟设备ID
   */
  getCommonDeviceId() {
    const { env } = this.opts;
    return new Promise(function(resolve, reject) {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.width = 0;
      iframe.height = 0;
      iframe.setAttribute('src', IFRAME_URL[env]);
      document.body.appendChild(iframe);
      iframe.addEventListener('load', () => {
        try {
          if (iframe.contentWindow) {
            const getDeviceId = iframe.contentWindow.window['getDeviceId'];
            if (getDeviceId) {
              resolve(getDeviceId());
            } else {
              reject();
            }
          } else {
            reject();
          }
        } catch(err) {
          reject();
        }
      });
    });
  }

  send (data, options, uidFunc) {
    // 设置跨域
    if (window.location.host.indexOf('localhost') !== -1) {
      document.domain = 'localhost';
    } else if (window.location.host.indexOf('xiaopeng.local') !== -1) {
      document.domain = 'xiaopeng.local';
    } else if (window.location.host.indexOf('xiaopeng.com') !== -1) {
      document.domain = 'xiaopeng.com';
    }

    const _this = this;
    const ls = window.localStorage;
    if (ls.getItem('newDeviceId')) {
      // 本地已有统一前端虚拟设备ID
      Object.assign(data, { nls: ls.getItem('newDeviceId') });
      _this.sendData(data, options, uidFunc);
    } else {
      // 跨域获取统一前端虚拟设备ID
      this.getCommonDeviceId().then(function(nls) {
        ls.setItem('newDeviceId', nls);
        Object.assign(data, { nls: nls });
        _this.sendData(data, options, uidFunc);
      }).catch(function() {
        _this.sendData(data, options, uidFunc);
      });
    }
  }

  static getCookie (name) {
    return getCookie(name)
  }

  static getOrCreateLocalId () {
    return getOrCreateLocalId()
  }
}

export default Report
